<script src="../../routes/routes.js"></script>
<template>
  <div>
    <md-table v-model="unconfirmed" :table-header-color="tableHeaderColor">
      <md-table-row slot="md-table-row" slot-scope="{ item }" @click="collect(item)">
        <md-table-cell md-label="ID">{{ item.id }}</md-table-cell>
        <md-table-cell md-label="Date">{{ new Date(item.date.seconds*1000) }}</md-table-cell>
        <md-table-cell md-label="Quantity">{{ item.quantity }}</md-table-cell>
        <md-table-cell md-label="Total">{{ item.quantity*item.offer }}</md-table-cell>
        <md-table-cell md-label="">
            <md-button  @click="collect(item)">confirm</md-button>
        </md-table-cell>
      </md-table-row>
    </md-table>

    <div>
      <md-dialog :md-active.sync="showDialog">
        <md-dialog-title>Confirm Offer</md-dialog-title>

        <h3 class="text-center">{{dialogId}}</h3>
        <p class="text-center"> Price: {{price}} Quantity: {{count}}</p>
        <img :src="dialogImage" alt="order">
        <md-dialog-actions>
          <md-button class="md-primary" @click="showDialog = false">Close</md-button>
          <md-button class="md-primary" @click="updateCollect()">Confirm collected</md-button>
        </md-dialog-actions>
      </md-dialog>
    </div>

  </div>
</template>

<script>
  import firebase from '../../Firebase';
export default {
  name: "ordered-table",
  props: {
    tableHeaderColor: {
      type: String,
      default: ""
    },
    unconfirmed: {
        type : Array
    }
  },
  data() {
    return {
      selected: [],
      showDialog: false,
      dialogImage: "",
      dialogId: "",
        price: 0,
        count: 0,
    };
  },
  methods : {
      collect(item){
          this.showDialog = true;
          this.dialogId = item.id;
          this.dialogImage = item.image;
          this.price = item.offer*item.quantity;
          this.count = item.quantity;
      },
      updateCollect(){
          this.showDialog = false;
          firebase.firestore().collection("orders").doc(this.dialogId).update(
              {"collected" : true}
          ).then(() => console.log('updated'))


      }
  }
};
</script>
